import { render } from "./PerformanceDashboard.vue?vue&type=template&id=f6b8735a&scoped=true"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=js"

import "./PerformanceDashboard.vue?vue&type=style&index=0&id=f6b8735a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6b8735a"]])

export default __exports__